import { useEffect, useState } from 'react';
// Helpers
import {
  getCookieConsentFromCookies,
  setCookieConsentToCookies,
} from 'helpers/cookies';
// Ui
import Text from 'ui3/Text/Text';
import Button from 'ui3/Button/Button';
// Styles
import styles from './CookieConsent.module.scss';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    setIsVisible(!getCookieConsentFromCookies());
  }, []);

  const handleAccept = () => {
    setCookieConsentToCookies();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={styles.root}
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div className={styles.content}>
        <img src="/images/cookie.svg" alt="" className={styles.icon} />

        <div className={styles.textWrapper}>
          <Text id="cookie-consent-title" variant="h6">
            We Use Cookies
          </Text>
          <Text
            id="cookie-consent-description"
            variant="body2Regular"
            color="lights-medium"
          >
            We use cookies to improve your experience, analyze site traffic, and
            help our website work properly.
          </Text>
        </div>
      </div>

      <Button size="medium" className={styles.button} onClick={handleAccept}>
        Accept All
      </Button>
    </div>
  );
};

export default CookieConsent;
